import React from 'react';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl } from '../../_metronic/_helpers';

export function DeleteButton({ ...rest }) {
  return (
    <span
      {...rest}
      className="svg-icon w-25px h-25px d-flex align-items-center justify-content-center btn"
      style={{ padding: 5 }}
    >
      <SVG
        uniquifyIDs
        cacheRequests
        src={toAbsoluteUrl('/media/svg/senseworks/bin-1.svg')}
      />
    </span>
  );
}
